import { SearchFacetData } from 'modules/search/types/SearchFacetData';
import { EDUCATION_LEVELS } from 'utils/constants/general/educationLevels';

export const educationFacet = {
  id: 'educationFacet',
  name: 'education',
  get title() {
    return getText('Education Level');
  },
  type: 'array',
  options: Object.keys(EDUCATION_LEVELS),
  optionTitles: EDUCATION_LEVELS,
  sort: false,
} as const satisfies SearchFacetData;
